import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DepartmentMapGradeDetails from "./routes/DepartmentMapGradeDetails";

export default store => ({
  path: "grade",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "department-map-grade" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [DepartmentMapGradeDetails(store)],
});
